// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + "algolia-search" + ".js?" + "7f0af87e53497944b317" + "";
};